import fr from 'facet-rest';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import AttachedStatementDownloadButton
  from 'Components/AdvisorApp/Viewport/ApexAdminPortal/BulkRolloverRecommendationQuestionnaire/AttachedStatementDownloadButton';
import CheckboxStandardized from 'Components/ComponentLibrary/Components/Uncategorized/Checkbox';


export const BulkRolloverRecommendationQuestionnaireBaseOverride = fr.metaOverride()
  .overrideAll({
    hidden: true,
  })
  .nameOverride('householdId', { hidden: false })
  .nameOverride('createdAt', { hidden: false })
  .nameOverride('feePercentageAtFacet', { hidden: false, prompt: 'Facet Fee %' })
  .nameOverride('feePercentageAtOtherCustodian', { hidden: false, prompt: 'Other Custodian Fee %' })
  .nameOverride('feeComparisonDetails', { hidden: false, prompt: 'Details' });

export const BulkRolloverRecommendationQuestionnaireTable = fr.metaOverride({ base: BulkRolloverRecommendationQuestionnaireBaseOverride })
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('attachments', {
    hidden: false,
    readonly: false,
    _component: () => AttachedStatementDownloadButton,
  });


export const RolloverRecommendationQuestionnaireTimeline = fr.metaOverride({ base: BulkRolloverRecommendationQuestionnaireBaseOverride })
  .overrideAll({
    hidden: false,
    readonly: true,
  });

export const BulkRolloverRecommendationQuestionnaireDialog = fr.metaOverride({ base: BulkRolloverRecommendationQuestionnaireBaseOverride })
  .overrideAll({
    hidden: false,
    readonly: true,
  })
  .typeOverride('number', {
    _component: () => TextField,
    precision: null,
    _customProps: {
      inputProps: {
        inputMode: 'decimal',
      },
    },
  })
  .typeOverride('bool', {
    _component: () => CheckboxStandardized,
  })
  .typeOverride('string', {
    _component: () => TextField,
    multiline: true,
    rows: 5,
    maxRows: 10,
  })
  .nameOverride('feePercentageAtFacet', {
    _customProps: {
      placeholder: 'Facet fee percentage',
    },
  })
  .nameOverride('feePercentageAtOtherCustodian', {
    _customProps: {
      placeholder: 'Other custodian fee percentage',
    },
    readonly: false,
  })
  .nameOverride('feeComparisonDetails', {
    _component: () => TextField,
    multiline: true,
    rows: 10,
    maxRows: 10,
    _customProps: {
      placeholder: 'Enter Additional Details',
    },
    readonly: false,
  });


export const getBulkRolloverRecommendationQuestionnaireTableFilters = (collection, householdSearch) => [
  {
    name: 'householdId',
    overrideOptions: householdSearch ? householdSearch.map(search => ({
      name: `${search.attributes.primaryClientFirstName} ${search.attributes.primaryClientLastName} [${search.id}]`,
      value: search.id.toString(),
    })) : [],
    query: 'getRolloverRecommendationQuestionnaires',
    _setQueryParam: true,
  },
  {
    name: 'feePercentage',
    query: 'getRolloverRecommendationQuestionnaires',
  },
];
